import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningSolidIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 3.2c.735 0 1.41.405 1.76 1.05l10.8 20c.335.62.32 1.37-.04 1.975a2 2 0 0 1-1.72.975H5.2c-.705 0-1.36-.37-1.72-.975a2 2 0 0 1-.04-1.975l10.8-20A2 2 0 0 1 16 3.2m0 17.6c-.885 0-1.6.715-1.6 1.6S15.115 24 16 24s1.6-.715 1.6-1.6-.715-1.6-1.6-1.6m0-9.6c-.91 0-1.635.775-1.57 1.685l.37 5.2a1.197 1.197 0 0 0 2.39 0l.37-5.2a1.573 1.573 0 0 0-1.57-1.685z" })
});
export default SvgWarningSolidIcon;
